import styled, { css } from 'styled-components';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  width: 100%;
  height: ${({ height }) => height || 'auto'};
  position: relative;
  display: flex;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 490px;
  background-image: url(${({ image }) => image});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

const TextEmptyState = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  white-space: pre-wrap;
  position: absolute;
  top: ${({ position }) => (position ? 165 : 55)}px;
  width: 94%;
  .spacing {
    height: 30px;
  }
  .CTA {
    font-weight: 600;
    color: ${getColor('primary')};
    cursor: pointer;
  }
  ${({ top }) =>
    top &&
    css`
      top: ${top};
    `}
`;

const TitleContainer = styled.p`
  font-family: 'Hind';
  font-weight: 600;
  font-size: 20px;
  line-height: '26px';
  white-space: pre-line;
  justify-content: start;
`;

export { Container, ImageWrapper, TextEmptyState, TitleContainer };
